module.exports = __webpack_public_path__ + "img/logo-gopay_qris-inactive.dbcde766.svg";